import { Component, OnInit, Output, EventEmitter, inject, computed, Signal } from '@angular/core';

import { UserService } from '@aifs-shared/user/user.service';
import { FeatureService, FeatureType } from '@aifs-shared/feature/feature.service';

import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    imports: [RouterLink, RouterLinkActive]
})
export class UserMenuComponent implements OnInit {
    @Output() menuItemClicked = new EventEmitter<string>();

    private userService = inject(UserService);
    private features = inject(FeatureService);

    isApplicant: Signal<boolean> = computed(() => this.userService.isApplicant());
    isReturner: Signal<boolean> = computed(() => this.userService.isReturner());
    isSignedOut: Signal<boolean> = computed(() => !this.userService.isLoggedIn());
    hasApplication: Signal<boolean> = computed(() => this.userService.hasApplication());
    hasPreviousApplication: Signal<boolean> = computed(() => this.userService.hasPreviousApplication());
    needsUrgentContact: Signal<boolean> = computed(() => this.userService.mustContactCAUrgently());
    isOrWasPlaced: Signal<boolean> = computed(() => {
        return (this.userService.isPlaced()) || (this.userService.wasPlaced());
    });

    constructor() { }

    ngOnInit() {
        this.calculateRoleBasedSettings();
    }

    calculateRoleBasedSettings(): void {
        if (!this.features.areFeaturesLoaded()) {
            this.features.getFeatures()
                .subscribe((finished: boolean) => {
                    this.checkFeatureAvailability();
                });
        } else {
            this.checkFeatureAvailability();
        }
    }

    checkFeatureAvailability() {
        const role = this.userService.applicantRole();
        if (role) {

            // console.log(`Checking feature ${FeatureType.SelfProposal} = ${this.features.isFeatureEnabled(FeatureType.SelfProposal)}, Loaded = ${this.features.areFeaturesLoaded()}`);
            this.canSelfPropose = this.hasApplication() && this.features.isFeatureEnabled(FeatureType.SelfProposal) && role.canSelfPropose!;
            this.canViewOrientation = this.hasApplication() && this.features.isFeatureEnabled(FeatureType.Orientation);
        } else {
            this.canSelfPropose = false;
        }
    }

    navigateTo(url: string): void {
        this.menuItemClicked.emit(url);
    }

    // Self-proposal
    canSelfPropose = false;
    canViewOrientation = false;
}
